import { SET_BRANCH, SET_BRANCHES } from "../../constants/branchConstants";

const initialState = {
  branch: null,
  branches: [],
  filteredBranches: [],
};

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BRANCH:
      return {
        ...state,
        branch: action.branch,
      };
    case SET_BRANCHES:
      return {
        ...state,
        branches: action.filtered ? state.branches : action.branches,
        filteredBranches: action.filtered ? action.branches : state.filteredBranches,
      };
    default:
      return state;
  }
};

export default branchReducer;
